import { render, staticRenderFns } from "./DocxViewer.vue?vue&type=template&id=ea72fa62&scoped=true&"
import script from "./DocxViewer.vue?vue&type=script&lang=js&"
export * from "./DocxViewer.vue?vue&type=script&lang=js&"
import style0 from "./DocxViewer.vue?vue&type=style&index=0&id=ea72fa62&scoped=true&lang=css&"
import style1 from "./DocxViewer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea72fa62",
  null
  
)

export default component.exports